module.exports = __webpack_public_path__ + "static/img/Todo-mobile.b5171ecc.webp";